import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  OnInit
} from '@angular/core';

import { NavComponent } from './nav.component';
import { DynamicNavsDirective } from './dynamic-navs.directive';
import { EventService } from '../../../core/services/event.service';

@Component({
  selector: 'my-navs',
  template: `

<!-- Primer Nav -->
<div class = {{estilonavs}}>
<ul class="topnav margenes margenes-m" style="padding-left: calc(0px);">
<div *ngFor="let nav of navs" (click)="selectNav(nav)" [class.active]="nav.active">
  <a  href="javascript:void(0)">{{nav.title}}</a>
</div>
<!-- dynamic navs -->
<div *ngFor="let nav of dynamicNavs; let indice = index" (click)="selectNav(nav)" [class.active]="nav.active" >
  <a href="javascript:void(0)"class="btn-navs waves-light">{{nav.title}}<span class="mdi mdi-close-thick fas label-icon" *ngIf="nav.isCloseable" (click)="closeTab(nav)"></span></a>
</div>
</ul>
</div>

<ng-content></ng-content>
<ng-template dynamic-navs #container></ng-template>
  `,
  styleUrls: ['./navs.component.scss']

})
export class NavsComponent implements OnInit, AfterContentInit {

  dynamicNavs: NavComponent[] = [];
  navspantalla: string = '';
  estilonavs: string = '';

  @ContentChildren(NavComponent) navs: QueryList<NavComponent>;

  // almora
  @ViewChild(DynamicNavsDirective) dynamicTabPlaceholder: DynamicNavsDirective;
  //  @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;


  constructor(private _componentFactoryResolver: ComponentFactoryResolver,
    private eventService: EventService) {
  }


  // contentChildren are set
  ngAfterContentInit() {
    // get all active navs
    const activeTabs = this.navs.filter(nav => nav.active);

    // if there is no active nav set, activate the first    
    if (activeTabs.length === 0 && this.navs.length > 0) {
      setTimeout(() => {
        this.cargarNavs();
      }, 0);
    } 
  }
  
  cargarNavs(){    
    const activeTabs = this.navs.filter(nav => nav.active);

    // if there is no active nav set, activate the first    
    if (activeTabs.length === 0 && this.navs.length > 0) {
        this.selectNav(this.navs.first);
    }
  }

  openNav(title: string, template, data, isCloseable = false) {
    // get a component factory for our NavComponent
    if (title == null) {
      if (data.OPERACION == "INSERT") {
        title = "Registro nuevo";
      }
      if (data.OPERACION == "SELECT") {
        let myArray = JSON.stringify(data.LLAVES[0]);
        myArray = myArray.replace("{", "");
        myArray = myArray.replace("}", "");
        myArray = myArray.replace(/['"]+/g, '');
        var splitted = myArray.split(",");
        var split = splitted[0].split(":");
        var campo = split[1];
        title = campo + " (Editando)";
      }
    }

    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
      NavComponent
    );

    // fetch the view container reference from our anchor directive
    // almora
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
    //let viewContainerRef = this.dynamicTabPlaceholder;

    // create a component instance
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // set the according properties on our component instance
    const instance: NavComponent = componentRef.instance as NavComponent;
    instance.title = title;
    instance.template = template;
    instance.dataContext = data;
    instance.isCloseable = isCloseable;

    // remember the dynamic component for rendering the
    // nav navigation headers
    this.dynamicNavs.push(componentRef.instance as NavComponent);

    // set it active
    this.selectNav(this.dynamicNavs[this.dynamicNavs.length - 1]);

    this.eventService.subscribe('EventoCerrarMS_' + data.NAV_ID, (llaves) => {
      this.CerrarTab(llaves);
     
      if(data.LLAVES.length > 0){
        if(data.LLAVES[0].SYS02CON != null){
          this.eventService.cerrarTab(data.LLAVES[0].SYS02CON);
        }
      }
    });
  }

  selectNav(nav: NavComponent) {
    // deactivate all navs
    if(nav != null){
      this.navs.toArray().forEach(nav => (nav.active = false));
      this.dynamicNavs.forEach(nav => (nav.active = false));
  
      // activate the tab the user has clicked on.
      nav.active = true;
    }
  }

  closeTab(nav: NavComponent) {
    for (let i = this.dynamicNavs.length - 1; i >= 0; i--) {
      if (this.dynamicNavs[i] === nav) {
        // remove the tab from our array
        this.dynamicNavs.splice(i, 1);

        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        let numNavs = this.dynamicNavs.length;
        if (numNavs > 0) {
          this.selectNav(this.dynamicNavs[numNavs - 1]);
        } else {
            this.selectNav(this.navs.first);
        }
        break;
      }
    }
  }

  closeTab0() {
        // remove the tab from our array
        this.dynamicNavs.splice(0, 1);
        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(0);
    }

  closeActiveTab() {
    const activeTabs = this.dynamicNavs.filter(nav => nav.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }

  ngOnInit(): void {
    this.navspantalla = this.eventService.pantalla();
    if (this.navspantalla == undefined) {
      this.navspantalla = "horizontal";
    }

    var es_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (es_chrome) {
      if (this.navspantalla === "vertical") {
        this.estilonavs = 'vertical2'
      } else if (this.navspantalla === "horizontal") {
        this.estilonavs = 'horizontal2'
      } else {
        this.estilonavs = 'vertical2'
      }
    }

    var es_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (es_firefox) {
      if (this.navspantalla === "vertical") {
        this.estilonavs = 'vertical'
      } else if (this.navspantalla === "horizontal") {
        this.estilonavs = 'horizontal'
      } else {
        this.estilonavs = 'vertical'
      }
    }

  }

  CerrarTab(data) {
    this.closeActiveTab();
  }
}
